module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bg-gray-100 min-h-screen flex flex-col list-bouteilles"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('div', {
    staticClass: "p-2 space-y-3 pb-6"
  }, [_c('app-header', {
    staticClass: "text-white",
    attrs: {
      "icon": "bouteille"
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-xl font-semibold tracking-wide text-right"
  }, [_vm._v("Restitution bouteille"), _c('br'), _vm._v("en volume")])])]), _vm._v(" "), _c('action-bar', {
    staticClass: "!p-0 !m-0",
    attrs: {
      "back": {
        name: 'home'
      }
    }
  }, [_c('a', {
    staticClass: "inline-flex items-center gap-2 bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition",
    attrs: {
      "id": "main-action"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.restitution($event)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-more bg-primary"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Rendre")]), _vm._v(" ces bouteilles")])])]), _vm._v(" "), _c('filter-bar', {
    staticClass: "block pb-5",
    attrs: {
      "placeholderFilter": 'Recherche par code, fluide, otag',
      "type-history": "bouteille"
    },
    on: {
      "searchBarChanged": _vm.updateSearch
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 shadow-xl pb-28"
  }, [(this.bouteilles.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "loading"
  }, [_vm._v("Chargement des bouteilles"), _c('span', {
    staticClass: "point-1"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "point-2"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "point-3"
  }, [_vm._v(".")])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: " p-2 list list-bout rounded-2xl overflow-hidden shadow-2xl restitution",
    attrs: {
      "id": "bouteilles-item"
    }
  }, _vm._l((_vm.filtredBottles()), function(bout) {
    return _c('div', {
      key: bout.id,
      staticClass: "check odd:bg-white even:bg-[#F7FAFD]",
      attrs: {
        "data-fournisseur": bout.fournisseur
      }
    }, [_c('input', {
      staticClass: "peer sr-only",
      attrs: {
        "type": "checkbox",
        "id": 'restit-' + bout.id
      },
      on: {
        "change": function($event) {
          return _vm.changeUpdate(bout)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "flex items-start gap-3 cursor-pointer border border-transparent transition-all duration-200 bg-transparent peer-checked:bg-red-500/20 peer-checked:border-red-600 p-3",
      attrs: {
        "for": 'restit-' + bout.id
      }
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('p', {
      staticClass: "text-md text-primary"
    }, [_vm._v("\n                                Distributeur :\n                                "), _c('span', {
      staticClass: "font-bold"
    }, [(bout.fournisseur) ? [_vm._v(_vm._s(bout.fournisseur.nom))] : _vm._e()], 2)]), _vm._v(" "), _c('h2', {
      staticClass: "text-xl mt-1"
    }, [_vm._v("\n                                Bouteille "), _c('span', {
      staticClass: "font-bold"
    }, [(bout.nom) ? [_vm._v(_vm._s(bout.nom.nom))] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center gap-3 mt-3"
    }, [(bout.fluide) ? _c('div', {
      staticClass: "flex items-center gap-1 px-3 py-1 rounded-r-full -ml-3 text-white text-sm font-medium",
      class: bout.type === 'Fluide frigorigène' ?
        'bg-gaz-ff' :
        (bout.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')
    }, [_c('i', {
      staticClass: "inline-block h-5 w-5 mask mask-snow bg-white"
    }), _vm._v("\n                                    " + _vm._s(bout.fluide.nom) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex items-center gap-1"
    }, [_c('i', {
      staticClass: "inline-block h-5 w-5 mask mask-bouteille",
      class: bout.type === 'Fluide frigorigène' ?
        'bg-gaz-ff' :
        (bout.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')
    }), _vm._v(" "), _c('span', {
      staticClass: "text-md font-medium",
      class: bout.type === 'Fluide frigorigène' ?
        'text-gaz-ff' :
        (bout.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')
    }, [_vm._v(_vm._s(bout.code))])]), _vm._v(" "), (bout.otag) ? _c('div', {
      staticClass: "flex items-center gap-1"
    }, [_c('i', {
      staticClass: "inline-block h-6 w-6 mask mask-otag",
      class: bout.type === 'Fluide frigorigène' ?
        'bg-gaz-ff' :
        (bout.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')
    }), _vm._v(" "), _c('span', {
      staticClass: "text-md font-medium",
      class: bout.type === 'Fluide frigorigène' ?
        'text-gaz-ff' :
        (bout.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')
    }, [_vm._v(_vm._s(bout.otag))])]) : _vm._e()]), _vm._v(" "), (bout.otag) ? _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "w-full bg-gray-200 rounded-full h-2"
    }, [_c('div', {
      staticClass: "h-2 rounded-full",
      class: bout.type === 'Fluide frigorigène' ?
        'bg-gaz-ff' :
        (bout.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf'),
      style: (_vm.getProgressStyle(bout))
    })]), _vm._v(" "), _c('p', {
      staticClass: "text-sm text-gray-600 mt-1"
    }, [_vm._v("\n                                    " + _vm._s(bout.poids_net ? bout.poids_net : 0) + " kg /\n                                    " + _vm._s(bout.poids_max ? bout.poids_max : 0) + " kg\n                                ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex-shrink-0 mt-1"
    }, [_c('div', {
      staticClass: "checkbox-visual w-6 h-6 border-2 rounded border-gray-400 flex items-center justify-center transition-all duration-200"
    }, [_c('span', {
      staticClass: "check-icon hidden text-white font-bold text-lg leading-none"
    }, [_vm._v("×")])])])])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a2e21d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bouteille/RestitutionBouteilles.vue
// module id = 998
// module chunks = 0